<template>
  <div class="order-detail-page">
    <div class="page-header">
      <span class="page-title">订单详情</span>
      <el-button type="primary" plain size="small" icon="el-icon-back" @click="returnFn()">返回列表</el-button>
    </div>
    <div class='descriptionsBox'>
      <div v-if="rowData.orderInfo" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">订单信息</span>
          <span class='status-tag'>{{ rowData.orderInfo.order_status | ordersAllStatusFilter }}</span>
        </div>
        <el-descriptions class='mt15' :column='4' :colon="false">
          <el-descriptions-item label="订单编号">{{ rowData.orderInfo.order_no }}</el-descriptions-item>
          <el-descriptions-item label="服务名称" span="3">{{ rowData.orderInfo.service_name }}</el-descriptions-item>
          <el-descriptions-item label="订单金额">￥{{ rowData.orderInfo.amount || '0.00' }}</el-descriptions-item>
          <el-descriptions-item label="支付类型">{{ rowData.orderInfo.pay_type | orderPayTypesFilter }}</el-descriptions-item>
          <el-descriptions-item label="支付金额" span="2">￥{{ rowData.orderInfo.pay_amount }}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.couponInfo.coupon_batch" label="优惠券批次号">{{ rowData.couponInfo.coupon_batch }}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.couponInfo.coupon_batch" label="优惠券名称">{{ `优惠${ rowData.couponInfo.discount_num === 1 || rowData.couponInfo.discount_num === 0 ? '单': rowData.couponInfo.discount_num}次，每次优惠${rowData.couponInfo.discount}元`}}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.couponInfo.coupon_batch" label="优惠总金额">{{ `￥${(rowData.couponInfo.discount_num * rowData.couponInfo.discount).toFixed(2)}`}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="rowData.userInfo" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">患者信息</span>
          <el-button v-if="showChangeOrderPatientInfo" type="primary" size="small" @click="handleOpenChangeOrderPatientInfo">修改患者信息</el-button>
        </div>
        <el-descriptions class='mt15' :column='4' :colon="false">
          <el-descriptions-item label="姓名">{{ rowData.userInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ rowData.userInfo.tel }}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.id_card" label="残疾证">{{ rowData.orderInfo.id_card }}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.dis_type" label="残疾类型">
            <div>
              <span v-for="i in rowData.orderInfo.dis_type" :key="i" class="dis_type">{{ i | disabilityTypesFilter }}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.dis_type" label="残疾证照">
            <div v-if="rowData.orderInfo.img_urls && rowData.orderInfo.img_urls !== ''" class="cert-imgs">
              <el-image v-for="(url, index) in (rowData.orderInfo.img_urls.split(','))" :key="index" :src="url" :preview-src-list="(rowData.orderInfo.img_urls.split(','))" class="cert-img" fit="cover" />
            </div>
          </el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.dis_grade" label="残疾等级">{{ rowData.orderInfo.dis_grade }}</el-descriptions-item>
          <el-descriptions-item label="地址">{{ rowData.userInfo.hospital_name }}{{ rowData.userInfo.address }}{{ rowData.userInfo.bed_no }}</el-descriptions-item>
          <el-descriptions-item v-if="!isDis" label="下单时间">{{ (rowData.orderInfo.created_at * 1000) | formatDate('yyyy-MM-dd HH:mm:ss') }}</el-descriptions-item>
          <el-descriptions-item label="服务开始时间">{{ (rowData.userInfo.start_at * 1000) | formatDate('yyyy-MM-dd') }}</el-descriptions-item>
          <el-descriptions-item label="服务结束时间">{{ (rowData.userInfo.end_at * 1000) | formatDate('yyyy-MM-dd') }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">护工信息</span>
          <el-button v-if="showChangeOrderPatientInfo" type="primary" size="small" @click="handleOpenChangeOrderNurseInfo">指/改派护工</el-button>
        </div>
        <el-descriptions class='mt15' :column='5' :colon="false">
          <el-descriptions-item v-if="rowData.nurseInfo && rowData.nurseInfo.length > 0"  label="姓名">{{ rowData.nurseInfo[0].name }}</el-descriptions-item>
          <el-descriptions-item v-if="rowData.nurseInfo && rowData.nurseInfo.length > 0"  label="手机号">{{ rowData.nurseInfo[0].tel }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <template v-if="showNursingRecords">
        <div class="info-card mt20">
          <div class="info-card-head">
            <span class="info-card-title">护理记录</span>
          </div>
          <el-table class="record-table" :data="rowData.nurseRecordsInfo || []" style="width: 100%" :header-cell-style="{ background: '#fafafa', color: '#303133' }">
            <el-table-column minWidth="50" label="序号" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column minWidth="120" label="护士信息">
              <template slot-scope="{ row: { name, tel } }">
                <div class="nurse-cell">
                  <div class="nurse-name">{{ name }}</div>
                  <div class="nurse-tel">{{ tel }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column minWidth="160" label="服务时间">
              <template slot-scope="scope">
                <span v-if="isDis">{{ (scope.row.dis_start_at * 1000) | formatDate('MM-dd HH:mm') }} - {{ (scope.row.dis_end_at * 1000) | formatDate('MM-dd HH:mm') }}</span>
                <span v-else>{{ (scope.row.service_at * 1000) | formatDate('MM-dd HH:mm') }}</span>
              </template>
            </el-table-column>
            <el-table-column minWidth="160" label="服务项目">
              <template slot-scope="scope">
                <template v-if="scope.row.services && scope.row.services.length">
                  <span class="service-items-text" v-html="scope.row.services.map(i => `${ i.name}￥${i.price}`).join('、')"></span>
                </template>
              </template>
            </el-table-column>
            <el-table-column minWidth="120" label="本次服务费用">
              <template slot-scope="scope">
                <template v-if="scope.row.services && scope.row.services.length">
                  ￥{{ scope.row.services_total }}
                </template>
              </template>
            </el-table-column>
            <el-table-column minWidth="200" label="服务中照片">
              <template slot-scope="scope">
                <div class="imgbox" v-if="scope.row.img_urls && scope.row.img_urls.length">
                  <el-image
                    class='litimg2'
                    v-for="img in scope.row.img_urls"
                    :src="img"
                    :key="img"
                    fit="cover"
                    :preview-src-list="scope.row.img_urls">
                  </el-image>
                </div>
                <span v-else class="empty-text">—</span>
              </template>
            </el-table-column>
            <el-table-column v-if="isAdmin" minWidth="80" label="操作" align="center">
              <template slot-scope="scope">
                <el-link v-if="scope.$index ===  rowData.nurseRecordsInfo.length - 1" type="danger" @click="handleDelete(scope.row.id)">
                  <i class="el-icon-delete"></i>
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>

      <div v-if="rowData.cancelOrderInfo && !Array.isArray(rowData.cancelOrderInfo) && showCancelOrderInfo" class="info-card mt20">
        <div class="info-card-head">
          <span class="info-card-title">取消订单</span>
          <el-button v-if="showCancelOrder" type="primary" size="small" @click="handleOpenCancelOrder">结束服务</el-button>
        </div>
        <el-descriptions class='mt15' :column='4' :colon="false">
          <el-descriptions-item label="申请退款时间">{{ (rowData.cancelOrderInfo.refund_at * 1000) | formatDate('yyyy-MM-dd HH:mm') }}</el-descriptions-item>
          <el-descriptions-item label="总服务天数">{{ rowData.cancelOrderInfo.service_days_num }}</el-descriptions-item>
          <el-descriptions-item label="已服务天数">{{ rowData.cancelOrderInfo.nurse_records_num }}</el-descriptions-item>
          <el-descriptions-item label="应退款金额"><span class="refund-fee">￥{{ rowData.cancelOrderInfo.refund_fee }}</span></el-descriptions-item>
          <el-descriptions-item v-if="rowData.orderInfo && rowData.orderInfo.order_status === OrderAllStatus[5].val && delayTime" label="等待审核">
            <span class="delay-time">{{ delayTime }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <ChangeOrderPatientInfo ref="ChangeOrderPatientInfo" :type="type" @update="getList" />
    <ChangeOrderNurseInfo ref="ChangeOrderNurseInfo" @update="getList" />
    <CancelOrder ref="CancelOrder" @update="getList" />
  </div>
</template>

<script>
import { fetchOrderDetailById } from '@/api'
import { color } from 'mockjs/src/mock/random/color'
import { filterEnum } from '../../utils/filter'
import { DisabilityTypes, OrderAllStatus, OrderPayTypes } from '../../enum/orders'
import ChangeOrderPatientInfo from './components/ChangeOrderPatientInfo'
import ChangeOrderNurseInfo from './components/ChangeOrderNurseInfo'
import CancelOrder from './components/CancelOrder'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { delOrderServiceById } from '../../api'
import { isAdmin } from '../../utils/util'

export default {
  name: 'OrderDetail',
  components: { CancelOrder, ChangeOrderNurseInfo, ChangeOrderPatientInfo },
  data() {
    const isDate = new Date()
    return {
      OrderAllStatus,
      type: '',
      rowDataId: '',
      delayTime: Date.now(),
      fileList: [],
      thisDateS: `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()}`,
      thisDate: Date.parse(`${isDate.getFullYear()}/${isDate.getMonth() + 1}/${isDate.getDate()} 00:00:00`),
      rowData: [],
      editVisible: false,
      editForm: {
        id: '',
        nurse: '',
        inServicePicture: '',
        brokerage: '',
        selfcareAbility: '',
        modificationTime: `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()} ${isDate.getHours()}:${isDate.getMinutes()}`,
        nurse_tel: ''
      },
      editFormTitle: '',
      formLabelWidth: '153px',
      tableDataAdd: {},
      timer: null
    }
  },
  filters: {
    formatDate,
    ordersAllStatusFilter(val) {
      return filterEnum(val, OrderAllStatus).label
    },
    disabilityTypesFilter(val) {
      return filterEnum(val, DisabilityTypes).label
    },
    orderPayTypesFilter(val) {
      return filterEnum(val, OrderPayTypes).label || '-'
    }
  },
  computed: {
    isAdmin() {
      return isAdmin()
    },
    showNursingRecords() {
      const { order_status } = this.rowData.orderInfo || {}
      const trueList = [OrderAllStatus[3].val, OrderAllStatus[7].val, OrderAllStatus[4].val, OrderAllStatus[5].val, OrderAllStatus[6].val]
      return trueList.includes(order_status)
    },
    showCancelOrderInfo() {
      const { order_status } = this.rowData.orderInfo || {}
      const trueList = [OrderAllStatus[3].val, OrderAllStatus[5].val, OrderAllStatus[7].val]
      return trueList.includes(order_status)
    },
    showCancelOrder() {
      const { order_status } = this.rowData.orderInfo || {}
      const trueList = [OrderAllStatus[3].val, OrderAllStatus[5].val]
      return trueList.includes(order_status)
    },
    isDis() {
      return this.type === 'orders_foster' || this.type === 'orders_foster_records'
    },
    showChangeOrderPatientInfo() {
      const { order_status } = this.rowData.orderInfo || {}
      const trueList = [OrderAllStatus[2].val, OrderAllStatus[5].val, OrderAllStatus[4].val]
      return trueList.includes(order_status)
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.rowDataId = (location.search).split('id=')[1]
    this.getList()
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {

    handleDelete(record_id) {
      this.$confirm(`确定删除护理纪录吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delOrderServiceById({
            record_id
          }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    // 打开修改患者信息
    handleOpenChangeOrderPatientInfo() {
      this.$refs.ChangeOrderPatientInfo.handleOpen(this.rowData)
    },
    // 打开修改护士信息
    handleOpenChangeOrderNurseInfo() {
      this.$refs.ChangeOrderNurseInfo.handleOpen(this.rowData)
    },
    // 打开取消订单信息
    handleOpenCancelOrder() {
      this.$refs.CancelOrder.handleOpen(this.rowData)
    },
    color,
    returnFn() {
      if (this.type === 'orders_foster') {
        this.$router.push('/orders_foster')
        return
      }
      if (this.type === 'orders_foster_records') {
        this.$router.push('/orders_foster_records')
        return
      }
      this.$router.push('/orders')
    },
    getList() {
      const params = {
        order_id: this.rowDataId
      }
      fetchOrderDetailById(params)
        .then(res => {
          if (res.status) {
            this.rowData = res.data
            if (this.timer) {
              clearTimeout(this.timer)
              this.timer = null
            }
            if (res.data.cancelOrderInfo && res.data.cancelOrderInfo.elapsed_time && res.data.cancelOrderInfo.elapsed_time !== '0秒') {
              this.delayTime = res.data.cancelOrderInfo.elapsed_time
              this.timer = setTimeout(() => {
                this.getList()
              }, 1000)
            }
          }
        })
    },
    inputFn(_Text) {
      this.editForm[_Text] = (this.editForm[_Text]).replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.order-detail-page {
  padding: 16px 20px 30px;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.descriptionsBox {
  padding: 8px 0 0;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.status-tag {
  font-size: 13px;
  color: #26a4b2;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(38, 164, 178, 0.1);
}
.cert-imgs { display: flex; flex-wrap: wrap; gap: 10px; }
.cert-img { width: 90px; height: 90px; border-radius: 6px; border: 1px solid #ebeef5; }
.nurse-cell { line-height: 1.6; }
.nurse-name { font-weight: 600; color: #303133; }
.nurse-tel { color: #909399; font-size: 13px; }
.service-items-text { color: #606266; }
.empty-text { color: #c0c4cc; }
.refund-fee { color: #f56c6c; font-weight: 600; }
.delay-time { color: #f56c6c; font-weight: 600; }
.record-table {
  margin-top: 4px;
}
.imgbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .litimg2 {
    width: 44px;
    height: 44px;
    margin: 4px 6px 4px 0;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    object-fit: cover;
    cursor: zoom-in;
  }
}
.dis_type {
  white-space: nowrap;
}
.dis_type + .dis_type {
  &:before {
    content: '、';
  }
}
</style>
